import React from 'react';
import { FormHelperText, Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import { GooglePlacesAutocomplete } from '@/components/selects/GooglePlacesAutocomplete';
import { useFormikHelper } from '@/hooks/useFormikHelper';

const ADDRESS = 'address';

// An in-person meeting's location: a Google Places street address, saved to the task's `address`
const MeetingAddressField = ({ loading }) => {
	const { values, setFieldValue } = useFormikContext();
	const { getError, getErrorMessage } = useFormikHelper();

	return (
		<Grid container rowSpacing={1} columnSpacing={{ xs: 3, md: 2 }}>
			<Grid size={12}>
				<GooglePlacesAutocomplete
					address={values[ADDRESS]}
					error={getError(ADDRESS)}
					helperText={getErrorMessage(ADDRESS)}
					disabled={loading}
					onSelectAddress={(params) => setFieldValue(ADDRESS, params.addressLine1 ?? '')}
				/>
				<FormHelperText>Street address</FormHelperText>
			</Grid>
		</Grid>
	);
};

export default MeetingAddressField;
